import Vue from 'vue';
import { Message } from 'element-ui';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import storage from 'store';
import {
    USER_INFO,
    ACCESS_TOKEN,
    SHIFT_INFO,
    SHIFT_LIST,
    ROLE_LIST,
    ADDRESS_BOOK,
    ADDRESS_BOOK_TIME,
    USER_STORAGE,
    TENANT,
    CARINGFAST
} from '../utils/env';
import { loginApi, loginCodeApi, getShiftListApi, getShiftListV2Api } from '../api/common';
import { INTERFACE } from '../libs/namespace';

import data from '../libs/data.json';

Vue.use(Vuex);

// 创建Store实例
export default new Vuex.Store({
    // 存储状态值
    state: {
        nim_appKey: '0d5b9e74be1e6da1efebb96e77fb9578', // 测试：'fcc77a7a53ce61d66bb5d3c597be62d5' 正式：'0d5b9e74be1e6da1efebb96e77fb9578'
        lastSessions_haveData: false,
        lastSessions: [],
        lastSession: null,
        badge: 0,
        sessionModal: false,
        assignConversationId: '',
        INTERFACE,
        hospital: '',
        logo: 'https://chinacaring.oss-cn-shanghai.aliyuncs.com/chinacaring_logo2_transparent.png',
        Authorization: 'Basic ZmlsZTpmaWxlY2FyaW5nMjAxNw==',
        fileDIR: CARINGFAST,
        fileDIR_o: 'https://prm.chinacaring.com/api/caring1/',
        moduleQuestionLogo: 'http://chinacaring.oss-cn-shanghai.aliyuncs.com/module.png',
        baiduUrl: 'https://www.baidu.com/',
        entryLogo: 'http://chinacaring.oss-cn-shanghai.aliyuncs.com/create.png',
        editLogo: 'http://chinacaring.oss-cn-shanghai.aliyuncs.com/edit.png',
        access_token: '', // debug data
        refresh_token: '',
        userInfo: null,
        authorities: [],
        expires_in: '',
        menuTabs: [{
            id: 0,
            type: 'home',
            title: '首页',
            name: 'home_0',
        }, ], // 每一项应该必须有type,title,id三个字段，name=type+'_'+id，不同type的id可以相同
        activeMenuTabIndex: 0,
        options: data,
        refreshPatientList: false,
        refreshTeam: false,
        refreshOrganization: false,
        editable: false,
        refreshQues: false,
        dept_list: [],
        tag_list: [],
        role_list: [],
        all_doctor: [],
        doctorInfo: null,
        // 问卷信息
        dataConfig: [], // 添加题目，没有模块时的题目列表
        modules: [], // 模块的配置
        moduleChoosed: -1,
        quesInfo: {}, // 选中的题目
        quesInfoIndex: -1, // 选中的第几个题目
        quesName: '', // 问卷标题
        quesDesc: '', // 问卷说明
        source: 'create', // 保存还是编辑
        maxInnerId: 0,
        query_byid: {},
        // 表单设置属性
        questionnaireAttribute: {
            // 问卷名称
            name: '',
            // 问卷提示信息
            prompt: '',
            // 填写者权限
            userPermission: 'all',
            // 频率
            frequency: 'all',
            // 密码
            password: '',
            // 二维码
            showQRCode: false,
            // 是否需要验证码
            needVerificationCodeWhenSubmit: false,
            // 登陆用户填完后可修改
            modifyWhenLogin: false,
            // 最大条数限制 整型数值
            maxRecordQuantity: 0,
            // 每天固定时间开启
            openAtFixedTime: false,
            // 是否开启时间
            hasStartEndDate: false,
            // 开始日期
            startDate: '',
            // 结束日期
            endDate: '',
            // 开启时间
            startAndEndTimes: [{
                startTime: '',
                endTime: '',
            }, ],
            // 分值段说明
            scoreSegments: [{
                startScore: '',
                endScore: '',
                description: '',
            }, ],
            // 密码设置
        },
        passwordStatus: false,
        refreshData: 0,
        questId: '',
        status: 0,
        questionnaire: {},
        // 提交的答案
        username: '',
        questionnaireId: '',
        password: '',
        // 答案id
        answerId: '',
        // 查看的答案
        // 凭密码填写
        setPassword: '',
        // 问卷标题
        questionnaireName: '',
        // 问卷说明
        questionnairePrompt: '',
        // 问卷模块
        questionnaireModules: [],
        // 问卷所有的题目数量
        questionnaireIndex: 0,
        // 是否需要验证码
        needVerificationCodeWhenSubmit: false,
        // 二维码分享
        showQRCode: false,
        // 填写频率
        frequency: 'all',
        // 允许填写者登录后修改
        modifyWhenLogin: true,
        // 填写者身份验证
        userPermission: 'all',
        // 第三方介入
        uniqueId: '',
        // 是否开启回收
        recycle: true,
        routerName: 'questionnaire',
        themeColor: 'white',
        printObj: {
            patient_info: null,
            suggestionList: null,
            allQuestionList: null,
        },
        startPrint: false,
        // 业务名称
        businessName: '',
        rules: [],
        ruleId: '',
        // 基本信息
        // patient: '',
        jiu_zhen_xin_xi: '',
        xue_chang_gui: '',
        flag: {},
        basicInfo: {},
        patientSubmit: {},
        groupId: '',
        condition: '',

        activeKey: '',
        allSelectedKeys: [],
        user: {},
        roleList: [],
        shiftList: [],
        diseaseList: [],
        shift: {
            institution_id: '',
            institution_name: '',
            dept_id: '',
            dept_name: '',
            disease_id: '',
            disease_name: '',
            team_id: '',
            team_name: '',
        },
        medicalList: [],
        userMenus: [],
        tenant: {},
        Propaganda: '',
        im: {},
        is_platform: true
    },
    getters: {
        activeKey: (state) => state.activeKey,
        allSelectedKeys: (state) => state.allSelectedKeys,
        userMenus: (state) => state.userMenus,
        shift: (state) => state.shift,
        diseaseList: (state) => state.diseaseList,
        roleList: state => state.roleList,
        shiftList: (state) => state.shiftList,
        curDeptList: (state) => {
            const institution = state.shiftList &&
                state.shiftList.find(
                    (s) => s.institution_id == state.shift.institution_id,
                );
            return (institution && institution.shift_dept_responses) || [];
        },
        curDiseaseList: (state, getters) => {
            const dept = getters.curDeptList &&
                getters.curDeptList.find((s) => s.dept_id == state.shift.dept_id);
            return (dept && dept.shift_disease_responses) || [];
        },
        curTeamList: (state, getters) => {
            const disease = getters.curDiseaseList &&
                getters.curDiseaseList.find(
                    (s) => s.disease_id == state.shift.disease_id,
                );
            return (disease && disease.shift_team_responses) || [];
        },
        medicalList: (state) => state.medicalList,
        hasFilter: (state) => state.userMenus.find((u) => u.router === 'filter'),
        hasSlow: (state) => state.userMenus.find((u) => u.router === 'slow'),
        tenant: (state) => state.tenant,
        user: (state) => state.user,
        im: (state) => state.im,
        is_platform: state => state.is_platform
    },
    // 状态值的改变方法,操作状态值
    // 提交mutations是更改Vuex状态的唯一方法
    mutations: {
        setDeptList(state, dept_list) {
            state.dept_list = dept_list
        },
        setTagList(state, tag_list) {
            state.tag_list = tag_list
        },
        setAllDoctor(state, all_doctor) {
            state.all_doctor = all_doctor
        },
        setDoctorInfo(state, doctorInfo) {
            state.doctorInfo = doctorInfo
        },
        setRandomNumber(state) {
            state.randomNumber++
        },
        setAssignConversationId(state, assignConversationId) {
            state.assignConversationId = assignConversationId;
        },
        setLastSessionsHaveData(state, lastSessions_haveData) {
            state.lastSessions_haveData = lastSessions_haveData;
        },
        setLastSessions(state, lastSessions) {
            state.lastSessions = lastSessions;
        },
        setLastSession(state, lastSession) {
            state.lastSession = lastSession;
        },
        setBadge(state, badge) {
            state.badge = badge;
        },
        setSessionModal(state, sessionModal) {
            state.sessionModal = sessionModal;
        },
        setPropaganda(state, Propaganda) {
            state.Propaganda = Propaganda;
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        setAccessToken(state, access_token) {
            state.access_token = access_token;
        },
        setRefreshToken(state, refresh_token) {
            state.refresh_token = refresh_token;
        },
        setAuthorities(state, authorities) {
            state.authorities = authorities;
            state.editable = authorities.indexOf('document:edit') >= 0;
        },
        setExpiresIn(state, expires_in) {
            state.expires_in = expires_in;
        },
        setMenuTabs(state, menuTabs) {
            state.menuTabs = menuTabs;
        },
        setActiveMenuTabIndex(state, activeMenuTabIndex) {
            state.activeMenuTabIndex = activeMenuTabIndex;
        },
        setRefreshPatientList(state) {
            state.refreshPatientList = !state.refreshPatientList;
        },
        setRefreshTeam(state) {
            state.refreshTeam = !state.refreshTeam;
        },
        setRefreshOrganization(state) {
            state.refreshOrganization = !state.refreshOrganization;
        },

        setRefreshQues(state) {
            state.refreshQues = !state.refreshQues;
        },

        // 问卷相关
        pushDataConfig(state, dataConfig) {
            state.dataConfig.push(dataConfig);
        },
        clearDataConfig(state) {
            state.dataConfig = [];
            state.modules = [];
        },
        pushModules(state) {
            state.dataConfig.push({
                type: 'module',
                name: '',
                prompt: '',
                isSetScoreSegments: false, // 是否开启分值段说明
                questionIds: [],
                scoreSegments: [],
                questionList: [],
            });
        },
        changeModuleChoosed(state, moduleChoosed) {
            state.moduleChoosed = moduleChoosed;
        },
        setQueryByid(state, value) {
            state.query_byid = {};
            state.query_byid = value;
        },
        changeQuesInfo(state, quesInfo) {
            state.quesInfo = {};
            state.quesInfo = quesInfo;
        },
        changeQuesInfoIndex(state, quesInfoIndex) {
            state.quesInfoIndex = quesInfoIndex;
        },
        setInnerId(state, maxInnerId) {
            state.maxInnerId = maxInnerId;
        },
        setSource(state, source) {
            state.source = source;
        },
        changeQuestId(state, questId) {
            state.questId = '';
            state.questId = questId;
        },
        changeStatus(state) {
            state.status++;
        },
        pushRules(state, ruleList) {
            state.rules.push(ruleList);
        },
        changeRouterName(state, routerName) {
            state.routerName = routerName;
        },
        setRecycle(state, recycle) {
            state.recycle = recycle;
        },
        setNum(state) {
            state.num++;
        },
        setUniqueId(state, uniqueId) {
            state.uniqueId = uniqueId;
        },
        setQuestionnaireId(state, questionnaireId) {
            state.questionnaireId = questionnaireId;
        },
        // setQuestionnaire (state, questionnaire) {
        //   state.questionnaire = questionnaire
        // },
        setneedVerificationCodeWhenSubmit(state, needVerificationCodeWhenSubmit) {
            state.needVerificationCodeWhenSubmit = needVerificationCodeWhenSubmit;
        },
        setmodifyWhenLogin(state, modifyWhenLogin) {
            state.modifyWhenLogin = modifyWhenLogin;
        },
        setshowQRCode(state, showQRCode) {
            state.showQRCode = showQRCode;
        },
        setusername(state, username) {
            state.username = username;
        },
        setpassword(state, password) {
            state.password = password;
        },
        changePassword(state, setPassword) {
            state.setPassword = setPassword;
        },
        changequestId(state, questId) {
            state.questId = questId;
        },
        changeuserPermission(state, userPermission) {
            state.userPermission = userPermission;
        },
        setShareUrl(state, shareUrl) {
            state.shareUrl = shareUrl;
        },

        // 新增患者
        setFlag(state, { key, value }) {
            state.flag[key] = value;
        },
        setBasicInfo(state, { key, value }) {
            state.basicInfo[key] = value;
        },
        setJiuZhenXinXi(state, info) {
            state.jiu_zhen_xin_xi = info;
        },
        setXuChangGui(state, info) {
            state.xue_chang_gui = info;
        },
        setPatientSubmit(state, { key, value }) {
            state.patientSubmit[key] = value;
        },
        setGroupId(state, group) {
            state.groupId = group;
        },
        setConditionId(state, condition) {
            state.condition = condition;
        },
        setActiveKey(state, activeKey) {
            state.activeKey = activeKey;
        },
        setAllSelectedKeys(state, {
            type,
            key,
            name,
            extra,
            title,
            list,
        }) {
            if (type === 'add') {
                if (state.allSelectedKeys.find((a) => a.key === key)) {
                    state.activeKey = key;
                } else if (state.allSelectedKeys.length > 9) {
                    Message.warning('您创建的页面过多,请先关闭!');
                } else {
                    state.allSelectedKeys.push({
                        key,
                        name,
                        extra,
                        title,
                    });
                    state.activeKey = key;
                }
            }
            if (type === 'delete') {
                const index = state.allSelectedKeys.findIndex((a) => a.key === key);
                if (index !== -1) {
                    state.allSelectedKeys.splice(index, 1);
                }
            }
            if (type === 'allDelete') {
                state.allSelectedKeys = [];
            }
            if (type === 'allAdd') {
                state.allSelectedKeys = list;
            }
        },
        setUser(state, user) {
            state.user = user;
        },
        setRoleList(state, roleList) {
            state.roleList = roleList;
        },
        setShiftList(state, shiftList) {
            state.shiftList = shiftList;
        },
        setShiftIndex(state, shiftIndex) {
            state.shiftIndex = shiftIndex;
        },
        setDiseaseList(state, diseaseList) {
            state.diseaseList = diseaseList;
        },
        setShift(state, shift) {
            state.shift = {...state.shift, ...shift };
        },
        setUserMenus(state, userMenus) {
            state.userMenus = userMenus;
        },
        setMedicalList(state, medicalList) {
            state.medicalList = medicalList;
        },
        setTenant(state, tenant) {
            state.tenant = tenant;
        },
        setIm(state, im) {
            state.im = im;
        },
        setPlatform(state, is_platform) {
            state.is_platform = is_platform
        }
    },
    actions: {
        Login({ commit }, userInfo) {
            return new Promise((resolve, reject) => {
                if (userInfo.grant_type) {
                    loginApi(userInfo).then((res) => {
                        if (res.code === 0) {
                            commit('setUser', res.data);
                            commit('setAccessToken', res.data.access_token);
                            storage.set(USER_INFO, res.data, 7 * 24 * 60 * 60 * 1000);
                            storage.set(ACCESS_TOKEN, res.data.access_token, 7 * 24 * 60 * 60 * 1000);
                            resolve(res);
                        } else {
                            reject(res);
                        }
                    }).catch((error) => {
                        reject(error);
                    });
                } else {
                    loginCodeApi(userInfo).then(res => {
                        if (res.code === 0) {
                            commit('setUser', res.data);
                            commit('setAccessToken', res.data.access_token);
                            storage.set(USER_INFO, res.data, 7 * 24 * 60 * 60 * 1000);
                            storage.set(ACCESS_TOKEN, res.data.access_token, 7 * 24 * 60 * 60 * 1000);
                            resolve(res);
                        } else {
                            reject(res);
                        }
                    }).catch((error) => {
                        reject(error);
                    });
                }
            });
        },
        Logout({ commit, state }) {
            return new Promise((resolve, reject) => {
                try {
                  const { user } = state.user;
                  let id = state.user.user.id;
                  let tenant = state.tenant.tenant;
                  if (user && storage.get(SHIFT_INFO + id + tenant)) {
                      storage.set(USER_STORAGE + id + tenant, storage.get(SHIFT_INFO + id + tenant));
                  }
                  storage.remove(SHIFT_INFO + id + tenant);
                  storage.remove(SHIFT_LIST + id + tenant);
                  storage.remove(ADDRESS_BOOK + id + tenant);
                  storage.remove(ADDRESS_BOOK_TIME + id + tenant);
                  storage.remove(TENANT + id);
                  storage.remove(USER_INFO);
                  storage.remove(ACCESS_TOKEN);
                  commit('setUser', {});
                  commit('setAccessToken', '');
                  commit('setTenant', {});
                  commit('setActiveKey', '');
                  commit('setIm', {});
                  commit('setAllSelectedKeys', {
                      type: 'allDelete',
                  });
                  resolve({
                      code: 0,
                  });
                } catch (error) {
                  reject(error)
                }

            });
        },
        getShiftList({ commit, state }) {
            return new Promise((resolve, reject) => {
                getShiftListApi()
                    .then((res) => {
                        if (res.code === 0) {
                            commit('setShiftList', res.data);
                            storage.set(SHIFT_LIST + state.user.user.id + state.tenant.tenant, res.data);
                            let diseaseList = [];
                            res.data.forEach((s) => {
                                s.shift_dept_responses &&
                                    s.shift_dept_responses.forEach((d) => {
                                        d.shift_disease_responses &&
                                            d.shift_disease_responses.forEach((disease) => {
                                                diseaseList.push(disease);
                                            });
                                    });
                            });
                            diseaseList = diseaseList.filter(
                                (d, i) => diseaseList.findIndex(
                                    (item) => item.disease_id == d.disease_id,
                                ) === i,
                            );
                            commit('setDiseaseList', diseaseList);
                            const oldShift = storage.get(USER_STORAGE + state.user.user.id + state.tenant.tenant);
                            let oldInstitution;
                            let oldDept;
                            let oldDisease;
                            let oldTeam;
                            if (oldShift) {
                                oldInstitution = res.data && res.data.length ?
                                    res.data.find(
                                        (d) => d.institution_id == oldShift.institution_id,
                                    ) || {} : {};
                                oldDept = oldInstitution.shift_dept_responses &&
                                    oldInstitution.shift_dept_responses.length ?
                                    oldInstitution.shift_dept_responses.find(
                                        (d) => d.dept_id == oldShift.dept_id,
                                    ) || {} : {};
                                oldDisease = oldDept.shift_disease_responses &&
                                    oldDept.shift_disease_responses.length ?
                                    oldDept.shift_disease_responses.find(
                                        (d) => d.disease_id == oldShift.disease_id,
                                    ) || {} : {};
                                oldTeam = oldDisease.shift_team_responses &&
                                    oldDisease.shift_team_responses.length ?
                                    oldDisease.shift_team_responses.find(
                                        (t) => t.team_id == oldShift.team_id,
                                    ) || {} : {};
                            }
                            let institution;
                            let dept;
                            let disease;
                            let
                                team;
                            if (oldInstitution && oldInstitution.institution_id) {
                                institution = oldInstitution;
                            } else {
                                institution = res.data && res.data.length ? res.data[0] : {};
                            }

                            if (oldDept && oldDept.dept_id) {
                                dept = oldDept;
                            } else {
                                dept = institution.shift_dept_responses &&
                                    institution.shift_dept_responses.length ?
                                    institution.shift_dept_responses[0] : {};
                            }

                            if (oldDisease && oldDisease.disease_id) {
                                disease = oldDisease;
                            } else {
                                disease = dept &&
                                    dept.shift_disease_responses &&
                                    dept.shift_disease_responses.length ?
                                    dept.shift_disease_responses[0] : {};
                            }

                            if (oldTeam && oldTeam.team_id) {
                                team = oldTeam;
                            } else {
                                team = disease &&
                                    disease.shift_team_responses &&
                                    disease.shift_team_responses.length ?
                                    disease.shift_team_responses[0] : {};
                            }

                            commit('setShift', {
                                institution_id: institution.institution_id,
                                institution_name: institution.institution_name,
                                dept_id: dept.dept_id,
                                dept_name: dept.dept_name,
                                disease_id: disease.disease_id,
                                disease_name: disease.disease_name,
                                team_id: team.team_id,
                                team_name: team.team_name,
                            });

                            storage.set(
                                SHIFT_INFO + state.user.user.id + state.tenant.tenant, {
                                    institution_id: institution.institution_id,
                                    institution_name: institution.institution_name,
                                    dept_id: dept.dept_id,
                                    dept_name: dept.dept_name,
                                    disease_id: disease.disease_id,
                                    disease_name: disease.disease_name,
                                    team_id: team.team_id,
                                    team_name: team.team_name,
                                },
                                7 * 24 * 60 * 60 * 1000,
                            );

                            const userMenus = team.menu_list ||
                                disease.menu_list ||
                                dept.menu_list ||
                                institution.menu_list || [];
                            commit('setUserMenus', userMenus);

                            if (userMenus.length) {
                                if (userMenus[0] && userMenus[0].child_menus.length) {
                                    commit('setAllSelectedKeys', {
                                        type: 'add',
                                        name: userMenus[0].child_menus[0].router,
                                        title: userMenus[0].child_menus[0].name,
                                        key: userMenus[0].child_menus[0].router,
                                        extra: {},
                                    });
                                } else if (userMenus[0]) {
                                    commit('setAllSelectedKeys', {
                                        type: 'add',
                                        name: userMenus[0].router,
                                        title: userMenus[0].name,
                                        key: userMenus[0].router,
                                        extra: {},
                                    });
                                }
                            }
                            resolve(res);
                        } else {
                            reject(res);
                        }
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getShiftListV2({ commit, state }) {
            return new Promise((resolve, reject) => {
                getShiftListV2Api().then((res) => {
                    if (res.code === 0 && res.data.length) {
                        commit('setRoleList', res.data);
                        storage.set(ROLE_LIST + state.user.user.id + state.tenant.tenant, res.data);

                        const role = res.data[0].shift_institution_responses || [];
                        commit('setShiftList', role);
                        storage.set(SHIFT_LIST + state.user.user.id + state.tenant.tenant, role);
                        let diseaseList = [];
                        role.forEach((s) => {
                            s.shift_dept_responses &&
                                s.shift_dept_responses.forEach((d) => {
                                    d.shift_disease_responses &&
                                        d.shift_disease_responses.forEach((disease) => {
                                            diseaseList.push(disease);
                                        });
                                });
                        });
                        diseaseList = diseaseList.filter(
                            (d, i) => diseaseList.findIndex(
                                (item) => item.disease_id == d.disease_id,
                            ) === i,
                        );
                        commit('setDiseaseList', diseaseList);
                        const oldShift = storage.get(USER_STORAGE + state.user.user.id + state.tenant.tenant);
                        let oldInstitution;
                        let oldDept;
                        let oldDisease;
                        let oldTeam;
                        if (oldShift) {
                            oldInstitution = role && role.length ?
                                role.find(
                                    (d) => d.institution_id == oldShift.institution_id,
                                ) || {} : {};
                            oldDept = oldInstitution.shift_dept_responses &&
                                oldInstitution.shift_dept_responses.length ?
                                oldInstitution.shift_dept_responses.find(
                                    (d) => d.dept_id == oldShift.dept_id,
                                ) || {} : {};
                            oldDisease = oldDept.shift_disease_responses &&
                                oldDept.shift_disease_responses.length ?
                                oldDept.shift_disease_responses.find(
                                    (d) => d.disease_id == oldShift.disease_id,
                                ) || {} : {};
                            oldTeam = oldDisease.shift_team_responses &&
                                oldDisease.shift_team_responses.length ?
                                oldDisease.shift_team_responses.find(
                                    (t) => t.team_id == oldShift.team_id,
                                ) || {} : {};
                        }
                        let institution;
                        let dept;
                        let disease;
                        let
                            team;
                        if (oldInstitution && oldInstitution.institution_id) {
                            institution = oldInstitution;
                        } else {
                            institution = role && role.length ? role[0] : {};
                        }

                        if (oldDept && oldDept.dept_id) {
                            dept = oldDept;
                        } else {
                            dept = institution.shift_dept_responses &&
                                institution.shift_dept_responses.length ?
                                institution.shift_dept_responses[0] : {};
                        }

                        if (oldDisease && oldDisease.disease_id) {
                            disease = oldDisease;
                        } else {
                            disease = dept &&
                                dept.shift_disease_responses &&
                                dept.shift_disease_responses.length ?
                                dept.shift_disease_responses[0] : {};
                        }

                        if (oldTeam && oldTeam.team_id) {
                            team = oldTeam;
                        } else {
                            team = disease &&
                                disease.shift_team_responses &&
                                disease.shift_team_responses.length ?
                                disease.shift_team_responses[0] : {};
                        }

                        commit('setShift', {
                            institution_id: institution.institution_id,
                            institution_name: institution.institution_name,
                            dept_id: dept.dept_id,
                            dept_name: dept.dept_name,
                            disease_id: disease.disease_id,
                            disease_name: disease.disease_name,
                            team_id: team.team_id,
                            team_name: team.team_name,
                        });

                        storage.set(
                            SHIFT_INFO + state.user.user.id + state.tenant.tenant, {
                                institution_id: institution.institution_id,
                                institution_name: institution.institution_name,
                                dept_id: dept.dept_id,
                                dept_name: dept.dept_name,
                                disease_id: disease.disease_id,
                                disease_name: disease.disease_name,
                                team_id: team.team_id,
                                team_name: team.team_name,
                            },
                            7 * 24 * 60 * 60 * 1000,
                        );

                        const userMenus = team.menu_list ||
                            disease.menu_list ||
                            dept.menu_list ||
                            institution.menu_list || [];
                        commit('setUserMenus', userMenus);

                        if (userMenus.length) {
                            if (userMenus[0] && userMenus[0].child_menus.length) {
                                commit('setAllSelectedKeys', {
                                    type: 'add',
                                    name: userMenus[0].child_menus[0].router,
                                    title: userMenus[0].child_menus[0].name,
                                    key: userMenus[0].child_menus[0].router,
                                    extra: {},
                                });
                            } else if (userMenus[0]) {
                                commit('setAllSelectedKeys', {
                                    type: 'add',
                                    name: userMenus[0].router,
                                    title: userMenus[0].name,
                                    key: userMenus[0].router,
                                    extra: {},
                                });
                            }
                        }
                        resolve(res);
                    } else {
                        reject(res);
                    }
                }).catch((error) => {
                    reject(error);
                })
            })
        },
        setShiftStore({ commit, state }, shift) {
            commit('setShift', shift);
            storage.set(
                SHIFT_INFO + state.user.user.id + state.tenant.tenant, {...state.shift, ...shift },
                7 * 24 * 60 * 60 * 1000,
            );
            window.location.reload();
        },
    },
    plugins: process.env.NODE_ENV === 'development' ? [createLogger()] : [],
});
